import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { Link } from "react-router-dom";
import DropdownPropertys from "../dropdown/DropdownPropertys";
import DropdownComponent from "../dropdown/DropdownComponent";
import DropdownInput from "../dropdown/DropdownInput";
import { StoreContext } from "../../context/StoreContext";
import DropdownMulti from "../dropdown/DropdownMulti";
import DropdownPayment from "../dropdown/DropdownPayment";
import { quarterARY, rentFqcyARY } from "../CommonFun";
import AutoMultiSearch from "../CustomizedHook/AutoMultiSearch";
import DropdownQuarter from "../dropdown/DropdownQuarter";

export default function PropertyFilter() {
    const { completionType,fetchCompletionType, purposeType, fetchPurposeType, categoriesType, fetchCategoriesType, cityData, fatchCity } = useContext(AuthContext);
    const { localityData, fatchLocality } = useContext(StoreContext);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [price, setPrice] = useState(50);
    const [homeSize, setHomeSize] = useState(50);
    const [landSize, setLandSize] = useState(50);
    const [propertyTab, setPropertyTab] = useState("forProperties");
    const [combinedData, setCombinedData] = useState([]);
    const [bannerFilter, setBannerFilter] = useState({
        purpose: "sale",
        categorySlug: "",
        categories: [],
        bedRooms: [],
        baths: [],
        location: "",
        completion: "all",
        maxArea: "",
        minArea: "",
        locality: "",
        maxPrice: "",
        minPrice: "",
        rent_frequency: "yearly",
        frequency: false,
        city: "",
    });
    const [bnrFilterPJT, setBnrFilterPJT] = useState({
        categoryName: [],
        categories: [],
        minArea: "",
        maxArea: "",
        minPrice: "",
        maxPrice: "",
        completionType: "",
        rentFrequency: "",
        completionPercentage: "",
        completionDate: "",
        paymentPlan: "",
        country: "",
        state: "",
        city: "",
        locality: "",
        searchValue: "",
        completion: "all",
        purpose: "Sale",
        baths: [],
        bedRooms: [],
        rent_frequency: "",
    });
    const handleTab = (name) => setPropertyTab(name);

    // useEffect(() => {
    //     if (purposeType.length > 0) {
    //         let purposeData = purposeType[0];
    //         setBannerFilter({ ...bannerFilter, "purpose": purposeData?.type });
    //     }
    // }, [purposeType]);

    useEffect(() => {
        const updatedCityData = cityData.map((city) => ({ name: city.cityName, Keyname: "city" }));
        const updatedLocalityData = localityData.map((locality) => ({ name: locality.name, Keyname: "locality" }));
        const combined = [...updatedCityData, ...updatedLocalityData];
        setCombinedData(combined);
    }, [localityData, cityData]);

    const filterCallBack = (option, name) => {
        if (name === "purpose" || name === "completion") setBannerFilter({ ...bannerFilter, [name]: option });
        else setBannerFilter(option);
    };
    const filterPJTCallBack = (option, name) => {
        if (name === "purpose") setBnrFilterPJT({ ...bnrFilterPJT, [name]: option });
        else setBnrFilterPJT(option);
    };

    const toggleFilters = () => setIsFilterOpen(!isFilterOpen);

    useEffect(() => {
        fetchCompletionType();
        fetchPurposeType();
        fetchCategoriesType();
        fatchCity();
        fatchLocality();
    }, []);

    const handlePriceChange = (e) => {
        const value = e.target.value;
        setPrice(value);
        e.target.style.background = `linear-gradient(to right, #f15a24 0%, #f15a24 ${value}%, #fff ${value}%, white 100%)`;
    };

    const handleHomeSizeChange = (e) => {
        const value = e.target.value;
        setHomeSize(value);
        e.target.style.background = `linear-gradient(to right, #f15a24 0%, #f15a24 ${value}%, #fff ${value}%, white 100%)`;
    };

    const handleLandSizeChange = (e) => {
        const value = e.target.value;
        setLandSize(value);
        e.target.style.background = `linear-gradient(to right, #f15a24 0%, #f15a24 ${value}%, #fff ${value}%, white 100%)`;
    };

    const handleReset = () => {
        let data = {
            purpose: "sale",
            categorySlug: "",
            categories: [],
            bedRooms: [],
            baths: [],
            location: "",
            completion: "all",
            maxArea: "",
            minArea: "",
            locality: "",
            maxPrice: "",
            minPrice: "",
            rent_frequency: "yearly",
            city: "",
        };
        // fechLtsProperties(1, data);
        setBannerFilter(data);
    };
    let findPRtdata = `/property/${bannerFilter.purpose.toLowerCase() === "Rent".toLowerCase() ? "to-rent" : "for-sale"}`;
    let firstParamAdded = false;
    const addParam = (param, value) => {
        if (value) {
            findPRtdata += (firstParamAdded ? "&" : "/") + param + "=" + value;
            firstParamAdded = true;
        }
    };
    if (bannerFilter?.categories?.length > 0) addParam("categories", bannerFilter?.categories?.length > 0 ? bannerFilter?.categories.join("%2C") : "");
    else addParam("category", bannerFilter?.categorySlug ? bannerFilter?.categorySlug : "");
    addParam("completion", bannerFilter.purpose === "sale" ? (bannerFilter.completion !== "all" ? bannerFilter.completion : "") : "");
    addParam("rent_frequency", bannerFilter.purpose === "rent" ? (bannerFilter.rent_frequency !== "any" ? bannerFilter.rent_frequency : "") : "");
    addParam("price_min", bannerFilter.minPrice);
    addParam("price_max", bannerFilter.maxPrice);
    addParam("area_min", bannerFilter.minArea);
    addParam("area_max", bannerFilter.maxArea);
    addParam("bed", bannerFilter.bedRooms && bannerFilter.bedRooms.length > 0 ? bannerFilter.bedRooms : "");
    addParam("bath", bannerFilter.baths && bannerFilter.baths.length > 0 ? bannerFilter.baths : "");
    addParam("city", bannerFilter.city);
    addParam("locality", bannerFilter.locality);
    let findPJTdata = `/new-project`;
    let firstParamPRTAdded = false;
    const addParamPRT = (param, value) => {
        if (value) {
            findPJTdata += (firstParamPRTAdded ? "&" : "/") + param + "=" + value;
            firstParamPRTAdded = true;
        }
    };
    addParamPRT("categories", bnrFilterPJT?.categories?.length > 0 ? bnrFilterPJT?.categories.join("%2C") : "");
    addParamPRT("completion", bnrFilterPJT.completion !== "all" ? bnrFilterPJT.completion : "");
    addParamPRT("rent_frequency", bnrFilterPJT.rent_frequency !== "any" ? bnrFilterPJT.rent_frequency : "");
    addParamPRT("price_min", bnrFilterPJT.minPrice);
    addParamPRT("price_max", bnrFilterPJT.maxPrice);
    addParamPRT("area_min", bnrFilterPJT.minArea);
    addParamPRT("area_max", bnrFilterPJT.maxArea);
    addParamPRT("locality", bnrFilterPJT.locality);
    addParamPRT("city", bnrFilterPJT.city);
    addParamPRT("bed", bnrFilterPJT.bedRooms && bnrFilterPJT.bedRooms.length > 0 ? bnrFilterPJT.bedRooms : "");
    addParamPRT("bath", bnrFilterPJT.baths && bnrFilterPJT.baths.length > 0 ? bnrFilterPJT.baths : "");
    addParamPRT("pre_handover_payment_max", bnrFilterPJT.paymentPlan);
    addParamPRT("completion_percentage_max", bnrFilterPJT.completionPercentage);
    addParamPRT("handover_date", bnrFilterPJT.completionDate);

    return (
        <div>
            <div className="filter-tab-panel">
                <div className="tab-container">
                    <div className="tab-buttons">
                        <button className={`tab-btn${propertyTab == "forProperties" ? " active" : ""}`} onClick={() => handleTab("forProperties")}>
                            Properties
                        </button>
                        <button className={`tab-btn${propertyTab == "forNewProject" ? " active" : ""}`} onClick={() => handleTab("forNewProject")}>
                            New Project
                        </button>
                    </div>
                    <div className="tab-content">
                        <div id="tab1" className={`tab-pane ${propertyTab === "forProperties" ? "active" : ""}`}>
                            <div className="hero-dropdown-sec justify-content-center">
                                {purposeType.length > 0 && (
                                    <div className="tab-buttons hero-tab-btn">
                                        {purposeType.map((pType, i) => (
                                            <button
                                                className={`tab-btn${bannerFilter.purpose.toLowerCase() === pType.type.toLowerCase() ? " active" : ""}`}
                                                onClick={() => filterCallBack(pType.type, "purpose")}
                                                key={i}
                                            >
                                                {pType.oppositeName}
                                            </button>
                                        ))}
                                    </div>
                                )}
                                <div className="search-sec properties-search">
                                    {/* <AautocompleteSearch data={localityData} filterData={bannerFilter} filterCallBack={filterCallBack} kName="name" plshdr="locality" multiShow={false} /> */}
                                    <AutoMultiSearch
                                        data={combinedData}
                                        filterData={bannerFilter}
                                        filterCallBack={filterCallBack}
                                        kName="name"
                                        plshdr="Enter location"
                                        multiShow={false}
                                        handleReset={handleReset}
                                        isIcon={true}
                                    />
                                    <div className="tab-search-btn ">
                                        <Link to={findPRtdata} className="button">
                                            Search
                                        </Link>
                                    </div>
                                </div>
                                {bannerFilter?.purpose === "sale" ? (
                                    <div className="buy-tab-btn">
                                        <div className="tab-buttons">
                                            <button className={`tab-btn${bannerFilter.completion === "all" ? " active" : ""}`} onClick={() => filterCallBack("all", "completion")}>
                                                All
                                            </button>
                                            {completionType &&
                                                completionType.length > 0 &&
                                                completionType.map((item, i) => (
                                                    <button
                                                        key={i}
                                                        className={`tab-btn${bannerFilter.completion === item?.type ? " active" : ""}`}
                                                        onClick={() => filterCallBack(item.type, "completion")}
                                                    >
                                                        {item?.name}
                                                    </button>
                                                ))}
                                        </div>
                                    </div>
                                ) : (
                                    // <DropdownComponent name="Frequency" kName="rent_frequency" option={rentFqcyARY} bannerFilter={bannerFilter} filterCallBack={filterCallBack} />
                                    <DropdownComponent name="yearly" kName="rent_frequency" option={rentFqcyARY} bannerFilter={bannerFilter} filterCallBack={filterCallBack} />
                                )}
                                {categoriesType.length > 0 && <DropdownPropertys categoriesType={categoriesType} bannerFilter={bannerFilter} filterCallBack={filterCallBack} />}
                                {bannerFilter?.categorySlug === "Agriculture" || bannerFilter?.categorySlug === "Commercial" ? (
                                    <DropdownInput title="Area" plchdlr="Area (sqft)" bannerFilter={bannerFilter} filterCallBack={filterCallBack} minKey="minArea" maxKey="maxArea" />
                                ) : (
                                    <DropdownMulti name="Beds & Baths" bannerFilter={bannerFilter} filterCallBack={filterCallBack} />
                                )}
                                <DropdownInput title="Price" plchdlr="Price (AED)" bannerFilter={bannerFilter} filterCallBack={filterCallBack} minKey="minPrice" maxKey="maxPrice" />
                            </div>
                        </div>
                        <div id="tab3" className={`tab-pane project-tab-pane ${propertyTab === "forNewProject" ? "active" : ""}`}>
                            <div className="hero-dropdown-sec justify-content-center">
                                <div className="search-sec project-tab">
                                    {/* <AautocompleteSearch data={localityData} filterData={bnrFilterPJT} filterCallBack={filterPJTCallBack} kName="name" plshdr="locality" multiShow={false} /> */}
                                    <AutoMultiSearch
                                        data={combinedData}
                                        filterData={bnrFilterPJT}
                                        filterCallBack={filterPJTCallBack}
                                        kName="name"
                                        plshdr="Enter location"
                                        multiShow={false}
                                        handleReset={handleReset}
                                        isIcon={true}
                                    />
                                    <div className="tab-search-btn ">
                                        <Link to={findPJTdata} className="button">
                                            Search
                                        </Link>
                                    </div>
                                </div>
                                <DropdownPropertys categoriesType={categoriesType} bannerFilter={bnrFilterPJT} filterCallBack={filterPJTCallBack} />
                                <DropdownQuarter name="Handover By" kName="completionDate" option={quarterARY} filterData={bnrFilterPJT} filterCallBack={filterPJTCallBack} />
                                <DropdownPayment name="Payment Plan" bannerFilter={bnrFilterPJT} filterCallBack={filterPJTCallBack} hKey="paymentPlan" />
                                <DropdownPayment name="% Completion" bannerFilter={bnrFilterPJT} filterCallBack={filterPJTCallBack} hKey="completionPercentage" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
